import { ArrowRightBigIcon } from '@blocksuite/icons/rc';
import type { DocCollection } from '@blocksuite/store';
import { WorkspaceSubPath } from '@pique/core/shared';
import type { useI18n } from '@pique/i18n';
import type { createStore } from 'jotai';

import { openSettingModalAtom } from '../atoms';
import { DEFAULT_SETTING_TAB } from '../components/pique/setting-modal/types';
import type { useNavigateHelper } from '../hooks/use-navigate-helper';
import { registerPiqueCommand } from './registry';

export function registerPiqueNavigationCommands({
  t,
  store,
  docCollection,
  navigationHelper,
}: {
  t: ReturnType<typeof useI18n>;
  store: ReturnType<typeof createStore>;
  navigationHelper: ReturnType<typeof useNavigateHelper>;
  docCollection: DocCollection;
}) {
  const unsubs: Array<() => void> = [];
  unsubs.push(
    registerPiqueCommand({
      id: 'affine:goto-all-pages',
      category: 'affine:navigation',
      icon: <ArrowRightBigIcon />,
      label: t['com.pique.cmdk.affine.navigation.goto-all-pages'](),
      run() {
        navigationHelper.jumpToSubPath(docCollection.id, WorkspaceSubPath.ALL);
      },
    })
  );

  unsubs.push(
    registerPiqueCommand({
      id: 'affine:goto-collection-list',
      category: 'affine:navigation',
      icon: <ArrowRightBigIcon />,
      label: 'Go to Folders',
      run() {
        navigationHelper.jumpToCollections(docCollection.id);
      },
    })
  );

  unsubs.push(
    registerPiqueCommand({
      id: 'affine:open-settings',
      category: 'affine:navigation',
      icon: <ArrowRightBigIcon />,
      label: t['com.pique.cmdk.affine.navigation.open-settings'](),
      keyBinding: '$mod+,',
      run() {
        store.set(openSettingModalAtom, s => ({
          activeTab: DEFAULT_SETTING_TAB,
          open: !s.open,
        }));
      },
    })
  );

  return () => {
    unsubs.forEach(unsub => unsub());
  };
}
